@if (labelsWithCheck.length > 0 || tagsWithCheck.length > 0) {
  <div class="labels-container">
    @if (multiSelectType === MultiSelectType.LABEL) {
      @for (label of labelsWithCheck; track label.id) {
        <div class="checkbox-row">
          <input type="checkbox" [id]="label.name" [checked]="label.checked" (change)="checkLabel(label)" [disabled]="formDisabled" />
          <label [for]="label.name" class="checkbox-label"></label>
          @if (label.viewAllContent) {
            <label [for]="label.name" class="checkbox-option all-options" i18n>All labels</label>
          } @else {
            <label [for]="label.name" class="checkbox-option">{{ label.name }}</label>
          }

          @if (showControlButtons && !label.viewAllContent) {
            <div class="button-wrapper">
              <a (click)="addOrEditOption(label)" class="add-or-edit-option-button"><img src="assets/icons/pencil.svg" alt="" /></a>
              <a (click)="deleteOption(label)" class="delete-button"><img src="assets/icons/bin.svg" alt="" /></a>
            </div>
          }
        </div>
      }
    }
    @if (multiSelectType === MultiSelectType.TAG) {
      @for (tag of tagsWithCheck; track tag) {
        <div class="checkbox-row">
          @if (tag) {
            <input type="checkbox" [id]="tag.name" [checked]="tag.checked" (change)="checkTag(tag)" [disabled]="formDisabled" />
            <label [for]="tag.name" class="checkbox-label"></label>
            <label [for]="tag.name" class="checkbox-option">{{ tag.name }}</label>
            @if (showControlButtons) {
              <div class="button-wrapper">
                <a (click)="addOrEditOption(tag)" class="add-or-edit-option-button"><img src="assets/icons/pencil.svg" alt="" /></a>
                <a (click)="deleteOption(tag)" class="delete-button"><img src="assets/icons/bin.svg" alt="" /></a>
              </div>
            }
          } @else {
            <input type="checkbox" [id]="'all-tags'" [checked]="allTagsChecked" (change)="checkTag(tag)" [disabled]="formDisabled" />
            <label [for]="'all-tags'" class="checkbox-label"></label>
            <label [for]="'all-tags'" class="checkbox-option all-options" i18n>All tags</label>
          }
        </div>
      }
    }
  </div>
}

@if (labelsWithCheck.length === 0 && tagsWithCheck.length === 0) {
  <div class="labels-container">
    @switch (multiSelectType) {
      @case (MultiSelectType.TAG) {
        <ng-container i18n>No tags have been created yet.</ng-container>
      }
      @case (MultiSelectType.LABEL) {
        <ng-container i18n>No labels have been created yet.</ng-container>
      }
    }
  </div>
}

@if (showControlButtons) {
  <div class="add-new-option-wrapper">
    @switch (multiSelectType) {
      @case (MultiSelectType.LABEL) {
        <a (click)="addOrEditOption()"><ng-container i18n>Add new label</ng-container><i class="fa-solid fa-chevron-right"></i></a>
      }
      @case (MultiSelectType.TAG) {
        <a (click)="addOrEditOption()"><ng-container i18n>Add new tag</ng-container><i class="fa-solid fa-chevron-right"></i></a>
      }
    }
  </div>
}
